import React from 'react';
import {
    DateInput,
    required,
    TextInput,
    SimpleForm,
    DisabledInput,
    Edit,
    SelectInput,
    choices,
    CardActions,
    ListButton, 
    Toolbar, 
    ShowButton,
    SaveButton,
    BooleanInput,
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TitleField from '../controls/TitleField'
import LocationField from '../controls/LocationField'
import SanitizedTextInput from '../controls/SanitizedTextInput';
import ErrorBoundary from '../ErrorBoundary';

const whiteStyle = {
    background: 'white'
}

const timeRestrictionStyle = {
    visiblity: 'none'
}
const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const UserEditActions = ({ basePath, data, resource }) => (
    <CardActions style={cardActionStyle}>
        <ShowButton basePath={basePath} record={data} />
        <ListButton basePath={basePath} />
    </CardActions>
);


const UserCreateToolbar = props => (
    <Toolbar {...props} >
        <SaveButton
            label="save"
            redirect="list"
            submitOnEnter={true}
        />
    </Toolbar>
);


const HoursCodes = [
    { id: 0, name: "00"},
    { id: 1, name: "01"},
    { id: 2, name: "02"},
    { id: 3, name: "03"},
    { id: 4, name: "04"},
    { id: 5, name: "05"},
    { id: 6, name: "06"},
    { id: 7, name: "07"},
    { id: 8, name: "08"},
    { id: 9, name: "09"},
    { id: 10, name: "10"},
    { id: 11, name: "11"},
    { id: 12, name: "12"},
    { id: 13, name: "13"},
    { id: 14, name: "14"},
    { id: 15, name: "15"},
    { id: 16, name: "16"},
    { id: 17, name: "17"},
    { id: 18, name: "18"},
    { id: 19, name: "19"},
    { id: 20, name: "20"},
    { id: 21, name: "21"},
    { id: 22, name: "22"},
    { id: 23, name: "23"}
]

const MinutesCodes = [
    { id: 0, name: "00"},
    { id: 15, name: "15"},
    { id: 30, name: "30"},
    { id: 45, name: "45"}
]



const UserEdit = ({...props }) => (
    <ErrorBoundary>    
    <Edit actions={<UserEditActions />}   {...props}  title="Edit user">
        <SimpleForm toolbar={<UserCreateToolbar />} >
        
            <Table  style={{ margin: 'auto', width: '100%' }} >
                <TableBody  > 
                    <TableRow > 
                            <TableCell colSpan="2" ><SanitizedTextInput source="user_name"    label="Login ID" validate={required()} /></TableCell>
                    </TableRow>
                    <TableRow > 
                            <TableCell > <SanitizedTextInput source="first_name" label="First Name" validate={required()}/></TableCell>
                            <TableCell > <SanitizedTextInput source="last_name" label="Last Name" validate={required()}/></TableCell>
                    </TableRow>
                    <TableRow > 
                            <TableCell ><TitleField   validate={required()} /></TableCell>
                            <TableCell ><LocationField  validate={required()}  /></TableCell>
                    </TableRow>
                    <TableRow > 
                            <TableCell colSpan="2" ><BooleanInput source="is_active" label="Is Active?" /></TableCell>
                    </TableRow>
                    <TableRow > 
                            <TableCell ><BooleanInput source="is_ip" label="Is IP Address restriction applied?" /></TableCell>
                            <TableCell ><SanitizedTextInput source="ipaddress" label="IP Address" /></TableCell>
                    </TableRow>
                    <TableRow > 
                            <TableCell colSpan="2" ><BooleanInput source="time_restricted"    label="Is time restriction applied?" /></TableCell>
                    </TableRow>
                </TableBody>
            </Table>

            <div style={{width: '100%'}} >
            <Paper style={{width: '100%', overflowX: 'auto'}}>
            <Table style={{ width: '100%'}} size="small" aria-label="a dense table">
            <TableHead style={{background: "silver"}}>
                <TableRow>
                <TableCell>Days</TableCell>
                <TableCell align="center">Start Hours</TableCell>
                <TableCell align="center">Start Minutes</TableCell>
                <TableCell align="center">End Hours</TableCell>
                <TableCell align="center">End Minutes</TableCell>
                </TableRow>
            </TableHead>
            <TableBody style={{backgroundColor: "#dedfdf"}}>

                <TableRow >
                    <TableCell component="th" scope="row">
                    Monday
                    </TableCell>
                    <TableCell align="right"><SelectInput style={{ width: '2em'}} source="mon_start_hr"   label="" choices={HoursCodes} /></TableCell>
                    <TableCell align="right"><SelectInput style={{ width: '2em'}} source="mon_start_min"   label="" choices={MinutesCodes} /></TableCell>
                    <TableCell align="right"><SelectInput style={{ width: '2em'}} source="mon_end_hr"   label="" choices={HoursCodes} /></TableCell>
                    <TableCell align="right"><SelectInput style={{ width: '2em'}} source="mon_end_min"   label="" choices={MinutesCodes} /></TableCell>
                </TableRow>
                <TableRow >
                    <TableCell component="th" scope="row">
                    Teusday
                    </TableCell>
                    <TableCell align="right"><SelectInput style={{ width: '2em'}} source="tue_start_hr"   label="" choices={HoursCodes} /></TableCell>
                    <TableCell align="right"><SelectInput style={{ width: '2em'}} source="tue_start_min"   label="" choices={MinutesCodes} /></TableCell>
                    <TableCell align="right"><SelectInput style={{ width: '2em'}} source="tue_end_hr"   label="" choices={HoursCodes} /></TableCell>
                    <TableCell align="right"><SelectInput style={{ width: '2em'}} source="tue_end_min"   label="" choices={MinutesCodes} /></TableCell>
                </TableRow>
                <TableRow >
                    <TableCell component="th" scope="row">
                    Wednesday
                    </TableCell>
                    <TableCell align="right"><SelectInput style={{ width: '2em'}} source="wed_start_hr"   label="" choices={HoursCodes} /></TableCell>
                    <TableCell align="right"><SelectInput style={{ width: '2em'}} source="wed_start_min"   label="" choices={MinutesCodes} /></TableCell>
                    <TableCell align="right"><SelectInput style={{ width: '2em'}} source="wed_end_hr"   label="" choices={HoursCodes} /></TableCell>
                    <TableCell align="right"><SelectInput style={{ width: '2em'}} source="wed_end_min"   label="" choices={MinutesCodes} /></TableCell>
                </TableRow>
                <TableRow >
                    <TableCell component="th" scope="row">
                    Thursday
                    </TableCell>
                    <TableCell align="right"><SelectInput style={{ width: '2em'}} source="thu_start_hr"   label="" choices={HoursCodes} /></TableCell>
                    <TableCell align="right"><SelectInput style={{ width: '2em'}} source="thu_start_min"   label="" choices={MinutesCodes} /></TableCell>
                    <TableCell align="right"><SelectInput style={{ width: '2em'}} source="thu_end_hr"   label="" choices={HoursCodes} /></TableCell>
                    <TableCell align="right"><SelectInput style={{ width: '2em'}} source="thu_end_min"   label="" choices={MinutesCodes} /></TableCell>
                </TableRow>
                <TableRow >
                    <TableCell component="th" scope="row">
                    Friday
                    </TableCell>
                    <TableCell align="right"><SelectInput style={{ width: '2em'}} source="fri_start_hr"   label="" choices={HoursCodes} /></TableCell>
                    <TableCell align="right"><SelectInput style={{ width: '2em'}} source="fri_start_min"   label="" choices={MinutesCodes} /></TableCell>
                    <TableCell align="right"><SelectInput style={{ width: '2em'}} source="fri_end_hr"   label="" choices={HoursCodes} /></TableCell>
                    <TableCell align="right"><SelectInput style={{ width: '2em'}} source="fri_end_min"   label="" choices={MinutesCodes} /></TableCell>
                </TableRow>
                <TableRow >
                    <TableCell component="th" scope="row">
                    Saturday
                    </TableCell>
                    <TableCell align="right"><SelectInput style={{ width: '2em'}} source="sat_start_hr"   label="" choices={HoursCodes} /></TableCell>
                    <TableCell align="right"><SelectInput style={{ width: '2em'}} source="sat_start_min"   label="" choices={MinutesCodes} /></TableCell>
                    <TableCell align="right"><SelectInput style={{ width: '2em'}} source="sat_end_hr"   label="" choices={HoursCodes} /></TableCell>
                    <TableCell align="right"><SelectInput style={{ width: '2em'}} source="sat_end_min"   label="" choices={MinutesCodes} /></TableCell>
                </TableRow>
                <TableRow >
                    <TableCell component="th" scope="row">
                    Sunday
                    </TableCell>
                    <TableCell align="right"><SelectInput style={{ width: '2em'}} source="sun_start_hr"   label="" choices={HoursCodes} /></TableCell>
                    <TableCell align="right"><SelectInput style={{ width: '2em'}} source="sun_start_min"   label="" choices={MinutesCodes} /></TableCell>
                    <TableCell align="right"><SelectInput style={{ width: '2em'}} source="sun_end_hr"   label="" choices={HoursCodes} /></TableCell>
                    <TableCell align="right"><SelectInput style={{ width: '2em'}} source="sun_end_min"   label="" choices={MinutesCodes} /></TableCell>
                </TableRow>
            </TableBody>
            </Table>
        </Paper>
        </div>     
           
        </SimpleForm>
        
    </Edit>
    </ErrorBoundary>  
);

export default UserEdit;
